<template>
    <stripe-element-card
        class="lib-stripe-card"
        :pk="pk"
        @token="promiseFunctions.resolve($event)"
        @error="promiseFunctions.reject($event)"
        :element-style="style"
        ref="element"
    >
        <template v-slot:stripe-element-errors>
            <div id="stripe-element-errors" class="lib-form-error" role="alert"></div>
        </template>
    </stripe-element-card>
</template>

<script>
import {StripeElementCard} from '@vue-stripe/vue-stripe';

export default {
    name: "LibCard",
    components: {StripeElementCard},
    props: ['pk'],
    data() {
        return {
            style: {
                base: {
                    fontSize: "16px",
                    lineHeight: "1",
                    fontFamily: 'Lato, sans-serif',
                    color: '#172530',
                    '::placeholder': {
                        color: '#BDBEC1'
                    }
                }
            },
            promiseFunctions: {
                resolve() {
                    console.error("Promise not created")
                },
                reject() {
                    console.error("Promise not created")
                },
            }
        }
    },
    methods: {
        submit() {
            return new Promise((resolve, reject) => {
                this.promiseFunctions.resolve = resolve;
                this.promiseFunctions.reject = reject;
                this.$refs.element.submit();
            });
        }
    }
}
</script>

<style lang="scss">
@import "../../styles/prelude";

// Reset the styles from the VueStripe component
.lib-stripe-card #stripe-element-form {
    .StripeElement {
        box-shadow: revert;
        -webkit-transition: revert;
        transition: revert;
    }
    .StripeElement--focus {
        box-shadow: revert;
    }
    .StripeElement--webkit-autofill {
        background-color: revert !important;
    }
}

.lib-stripe-card #stripe-element-form {
    .StripeElement {
        @include form-field-width;
        box-sizing: border-box;
        background-color: $white;
        padding: 10px 20px;
        border: 1px solid var(--lib-border-color);
        height: 40px;
        border-radius: 3px;
    }

    &:hover .StripeElement {
        border-color: var(--lib-focus-border-color);
    }

    &:hover .StripeElement--invalid {
        border-color: $red;
    }

    .StripeElement--focus {
        border-color: var(--lib-focus-border-color);
        border-width: 2px;
        margin: -1px;
        height: 42px;
        outline: none;
    }

    .StripeElement--invalid {
        border-color: $red;
    }
}
</style>